import { render } from "./AccessLogExport.vue?vue&type=template&id=21f16e26"
import script from "./AccessLogExport.vue?vue&type=script&lang=ts"
export * from "./AccessLogExport.vue?vue&type=script&lang=ts"
script.render = render

export default script